module.exports = __webpack_public_path__ + "img/processing-security-mastercard.a9b5ea87.svg";